import { Link } from "react-router-dom";
import { ThemeToggle } from "./ThemeToggle";

export function Layout({ children }) {

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b">
        <nav className="mx-auto flex max-w-2xl items-center justify-between px-6 py-4">
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-sm font-medium text-foreground transition-colors hover:text-foreground"
            >
              Pak H. Lee
            </Link>
          </div>
          <div className="flex items-center gap-1">
            <ThemeToggle />
          </div>
        </nav>
      </header>
      <main className="mx-auto max-w-2xl px-6 py-12">{children}</main>
    </div>
  );
}
